import QueryStore from './QueryStore';
import IndexStore from './IndexStore';

const stores = {
  queryStore: new QueryStore(),
  indexStore: new IndexStore()
}

export default stores


// WEBPACK FOOTER //
// ./src/stores/index.ts